module.exports = __webpack_public_path__ + "media/bootstrap-icons/laptop-c96d49ea.svg";